@if (operations().length) {
  <div class="eco-opchg__wrapper">
    <table class="eco-opchg__table" aria-label="Variação por operação">
      <thead>
        <tr>
          <th scope="col">Operação</th>
          <th scope="col">Empresa</th>
          <th scope="col">Motivo</th>
          <th scope="col" class="eco-opchg__right">
            Em {{ startDate() ? (startDate() | vaultDate) : 'início' }}
          </th>
          <th scope="col" class="eco-opchg__right">
            Em {{ endDate() ? (endDate() | vaultDate) : 'fim' }}
          </th>
          <th scope="col" class="eco-opchg__right">Variação</th>
        </tr>
      </thead>
      <tbody>
        @for (op of visible(); track op.loanOperationId) {
          <tr class="eco-opchg__line">
            <td>
              <button
                type="button"
                class="eco-opchg__loan"
                [attr.aria-label]="'Abrir detalhes de ' + (op.sequentialId || 'operação')"
                (click)="loanSelected.emit(op.loanOperationId)">
                {{ op.sequentialId || 'Operação' }}
              </button>
            </td>
            <td>{{ companyName(op) }}</td>
            <td>{{ categoryLabels[op.category] || op.category }}</td>
            <td class="eco-opchg__right">
              @if (op.start !== null) {
                {{ op.start | vaultFormatCurrency: 2 }}
              } @else {
                <span class="eco-opchg__muted">não contava</span>
              }
            </td>
            <td class="eco-opchg__right">
              @if (op.end !== null) {
                {{ op.end | vaultFormatCurrency: 2 }}
              } @else {
                <span class="eco-opchg__muted">saiu</span>
              }
            </td>
            <td class="eco-opchg__right eco-opchg__value" [ngClass]="signClass(op.variation)">
              {{ op.variation | vaultFormatCurrency: 2 }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (hiddenCount() > 0) {
    <div class="eco-opchg__hidden">
      <span>
        {{ hiddenCount() }}
        {{ showAll() ? 'operações sem variação no período' : 'operações sem variação ocultas' }}
      </span>
      <app-button
        [label]="showAll() ? 'Esconder' : 'Mostrar todas'"
        theme="link"
        size="small"
        [noMargin]="true"
        (sendClick)="showAll.set(!showAll())" />
    </div>
  }
} @else {
  <p class="eco-opchg__empty">Nenhuma operação com variação no período.</p>
}
